import { useContext, useMemo } from 'react';
import _ from 'lodash';
import { MapContext } from '../../../contexts/MapContext';
import ButtonWithShortcut from '../../basics/ButtonWithShortcut';
import { SHORTCUTS } from '../../../constants/shortcuts';
import { captureEvent } from '../../../utils/analytics';
import InlineButton from '../../basics/InlineButton';

const ShowHideSelectedSectionsButton = ({
  selectedSectionIdSet,
  shortenText = false,
  className,
}) => {
  const {
    fields: { fieldSections, bulkHideSections, bulkShowSections },
  } = useContext(MapContext);

  const selectedSectionIdArray = useMemo(
    () =>
      selectedSectionIdSet.size
        ? Array.from(selectedSectionIdSet)
        : fieldSections.map((section) => section.id),
    [selectedSectionIdSet, fieldSections],
  );

  const filteredSections = useMemo(
    () =>
      selectedSectionIdSet.size
        ? fieldSections.filter((section) =>
            selectedSectionIdSet.has(section.id),
          )
        : fieldSections,
    [fieldSections, selectedSectionIdSet],
  );

  const shouldShow = useMemo(
    () => filteredSections.some((section) => !section.shown),
    [filteredSections],
  );

  const baseString = shouldShow ? 'show' : 'hide';

  return (
    <ButtonWithShortcut
      as={InlineButton}
      shortcut={SHORTCUTS.SHOW_HIDE_SECTIONS.key}
      color="link"
      className={`p-0 font-small text-muted align-self-end ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        captureEvent(
          `${
            selectedSectionIdSet.size ? 'section-group' : 'all-sections'
          }-visibility-toggled`,
          { visible: shouldShow },
        );
        return shouldShow
          ? bulkShowSections(selectedSectionIdArray)
          : bulkHideSections(selectedSectionIdArray);
      }}
    >
      {`${
        shortenText
          ? baseString
          : selectedSectionIdSet.size
          ? `${_.capitalize(baseString)} Selected`
          : `${_.capitalize(baseString)} All`
      }`}
    </ButtonWithShortcut>
  );
};

export default ShowHideSelectedSectionsButton;
